import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { times } from 'lodash';
/**
 * WordPress dependencies
 */

import { __, sprintf } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

function Stars(_ref) {
  var rating = _ref.rating;
  var stars = Math.round(rating / 0.5) * 0.5;
  var fullStarCount = Math.floor(rating);
  var halfStarCount = Math.ceil(rating - fullStarCount);
  var emptyStarCount = 5 - (fullStarCount + halfStarCount);
  return createElement("div", {
    "aria-label": sprintf(__('%s out of 5 stars'), stars)
  }, times(fullStarCount, function (i) {
    return createElement(Icon, {
      key: "full_stars_".concat(i),
      icon: "star-filled",
      size: 16
    });
  }), times(halfStarCount, function (i) {
    return createElement(Icon, {
      key: "half_stars_".concat(i),
      icon: "star-half",
      size: 16
    });
  }), times(emptyStarCount, function (i) {
    return createElement(Icon, {
      key: "empty_stars_".concat(i),
      icon: "star-empty",
      size: 16
    });
  }));
}

export default Stars;
//# sourceMappingURL=stars.js.map